import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

export const RemarksModal = ({
  open,
  onClose,
  onSubmit,
  commentData,
  setCommentData,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Your Remarks</DialogTitle>
      <DialogContent>
        <TextField
          label="Remarks"
          multiline
          rows={4}
          fullWidth
          value={commentData}
          onChange={(e) => setCommentData(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          disabled={!commentData}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
